<template>
    <div>
        <div class="navbar-menu home" :class="{'menu-is-open': menu_isOpen}">
            <MenuHead></MenuHead>
        </div>
        <b-navbar class="border-bottom border-light" toggleable="xs" :sticky="true" type="light" :class="{'is-down': !header.going_up && !menu_isOpen}">
            <div class="container">
                <div class="d-flex align-items-center justify-content-between w-100">
                    <div class="logo-wrapper">
                        <router-link tag="a" :to="$i18nRoute({name:'home'})" class="navbar-brand">
                            <img src="../assets/svg/logo-tds-orange.svg"
                                 class="d-inline-block align-top" alt="">
                        </router-link>
                    </div>
                    <div class="d-none d-lg-flex align-items-center justify-content-end w-100 navbar-menu home" v-if="!menu_isOpen">
                        <MenuHead></MenuHead>
                    </div>
                    <div class="d-flex align-items-center ml-2">
                        <!--<a href="/" class="search-wrapper&#45;&#45;search-icon-wrapper d-none d-md-inline-block mr-1">-->
                            <!--<div class="search-wrapper&#45;&#45;search-icon-wrapper&#45;&#45;btn">-->
                                <!--<img src="../assets/svg/icon-magnyfiningglass-light.svg" width="15" height="15">-->
                            <!--</div>-->
                        <!--</a>-->
                        <div class="d-inline-block">
                            <Login></Login>
                        </div>
                        <b-navbar-toggle class="d-lg-none" v-if="!menu_isOpen" @click="menu_isOpen = true" target="nav_collapse"></b-navbar-toggle>
                        <a v-if="menu_isOpen" @click="menu_isOpen = false" class="icon-hamburger-close p-0 ml-lg-3 d-lg-none">
                            <img src="../assets/svg/icon-hamburger-close.svg" width="30" height="30">
                        </a>
                    </div>
                </div>
            </div>
        </b-navbar>
    </div>
</template>
<script>
    // import Login from './Login'
    import MenuHead from "./MenuHead";
    export default {
        name: 'TDSHead',
        components: {
            MenuHead,
            // Login,
        },
        data() {
            return {
                menu_isOpen: false,
                header: {
                    scroll_position: 0,
                    going_up: true,
                    min_position: 400,
                },
            }
        },mounted() {
            window.addEventListener('scroll',this.headScroll);
        },watch: {
            menu_isOpen: function (val) {
                this.$store.commit('menu_open',val)
            }
        },methods: {
            headScroll() {
                let old_pos = this.header.scroll_position

                let supportPageOffset = window.pageYOffset !== undefined
                let isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat')
                // Verifico di quanto siamo scrollati verticalmente
                this.header.scroll_position = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop

                if (this.header.scroll_position > old_pos)
                    this.header.going_up = false
                if (this.header.scroll_position < old_pos)
                    this.header.going_up = true

                if (this.header.scroll_position < this.header.min_position)
                    this.header.going_up = true
            },
        }
    }
</script>
